// IE 2026 10 29 / ODOO-5800 (заказ Игоря: история изменений списка, ie-dm7 #114916)
// ВКЛАДКА «HISTORY OF CHANGES» СПИСКА (WIDGET-LIST; AttrListHistory.vue) — ЯДРО: чистая логика без store. Модель ответа бэка (контракт v2,
// common_modules/list_history_contract.py; ANSWERS-BE 29.10), настройки истории (F1), запрос params.history, сверка ответа с отправленным
// запросом по request.seq, раскрытие (detail), partial / continue_from. Ленту, «За записами», календарь, источники DS — куски K2–K4 (свои utils).
// Ответ: основной — record._doc.list_history (binding вкладки), раскрытие пакета / записи / определения DS — record._doc.list_history_detail
// (поле for); в каждом ответе contract: 2 и request: { <params.history как прислали>, seq, target[, events_offset] }.
// Основной ответ лёгкий: events = [], packets[].sample ≤ 3, у полей событий нет title*/path (подписи — fields[] по f) → раскрытие только запросом
// packet_id / record_id + answer_id. found: false в раскрытии → перезапросить основной ответ. Новые ключи модель пропускает молча.
// Выключатели фронта (store.setting, по умолчанию вкл): fe.ux.listHistory (компонент), fe.ux.listHistoryLocalExpand (раскрытие из пришедших
// events без запроса — при лёгком ответе не срабатывает), fe.ux.listHistoryAutoRead (автодочитывание partial, K5), fe.ux.listHistoryLiteFirst
// (первое открытие с lite = 1, затем полный ответ).
import { pmHistory_badgeText, pmHistory_fmt, pmHistory_dayLabel } from './pmHistory.js'

export const LH_CONTRACT = 2
export const LH_METHOD = 'list_history'
export const LH_BINDING = '_doc.list_history'
export const LH_DETAIL_BINDING = '_doc.list_history_detail'
export const LH_DEPTHS = ['week', 'month', 'quarter', 'year', 'all']
export const LH_SLICES = ['day', 'month']
export const LH_VIEWS = ['feed', 'records', 'calendar']   // подвкладки с запросом (params.history.view)
export const LH_TABS = ['feed', 'records', 'calendar', 'sources', 'definition']   // sources / definition — DS, без запроса (view 'feed')
export const LH_KINDS = ['created', 'changed', 'archived', 'deleted']
export const LH_KINDS_DS = [...LH_KINDS, 'load', 'recalc', 'definition']
export const LH_WHO = ['manual', 'load_1c', 'regulation', 'import', 'calc', 'task', 'system']
export const LH_FIELDS_TOP = 8   // группа Fields: первые N по бейджу, остальное — «+N more»
export const LH_BUSY_MS = 90000   // ожидание ответа снимается само (ошибка сети / бэк без updateDoc)
export const LH_PARTIAL_BLOCKS = ['selection', 'archived', 'journal', 'deleted', 'left', 'titles', 'loads', 'definition']
// ключи params.history, которые уходят как есть (строка / число); остальное — через свои правила в listHistory_request
const EXTRA_STR = ['packet_id', 'record_id', 'definition_audit_id', 'answer_id', 'continue_from', 'target', 'scope']
const EXTRA_NUM = ['events_offset', 'budget_sec']
const EXTRA_FLAG = ['lite', 'deep', 'left_selection']
const EXTRA_LIST = ['page_ids', 'page_keys', 'sources']

// КОНТРАКТ ДОЧЕРНИХ ВКЛАДОК (LhFeed / LhRecords / LhCalendar / LhSources / LhDefinition; K2–K4 не меняют, расширения — новыми необязательными props):
//   payload — снимок основного ответа (markRaw-КОПИЯ), detail — ответ раскрытия или null, ui — выбор пользователя { tab, packetOpen, recordOpen,
//   definitionOpen, detailWait (раскрытие запрошено, ответа ещё нет), lang }, t — функция перевода, widget_id. Оболочка — единственная, кто шлёт executeStoreMethod и пишет состояние.
//   emits: 'request' (патч params.history: { packet_id } | { record_id } | { definition_audit_id } | { events_offset } | { deep } | { all_fields } | { continue_from } …),
//   'open-record' ({ id, segment, version }), 'show-in-list' ({ rows, cols, source_segment }), 'close-detail'.
export const LH_CHILD_PROPS = ['payload', 'detail', 'ui', 't', 'widget_id']
export const LH_CHILD_EMITS = ['request', 'open-record', 'show-in-list', 'close-detail']

const num = (v) => { const n = Number(v); return Number.isFinite(n) ? n : 0 }
const str = (v) => (v == null ? '' : String(v))
const isObj = (v) => !!v && typeof v === 'object' && !Array.isArray(v)
const arr = (v) => (Array.isArray(v) ? v : [])
const flag01 = (v) => (v === 1 || v === true || v === '1' ? 1 : 0)

// выключатель фронта fe.ux.<name> (по умолчанию вкл); setting — (ключ, умолчание) → значение (store.setting)
export function listHistory_flag(setting, name) {
    try { return typeof setting !== 'function' || setting('fe.ux.' + str(name), true) !== false } catch (e) { return true }
}

// подпись объекта { title, title_uk, title_ru } на языке пользователя; фолбэк — title, затем key
export function listHistory_title(obj, lang = 'en') {
    if (!isObj(obj)) return str(obj)
    const L = str(lang).toLowerCase()
    const v = (L === 'uk' || L === 'ru') ? str(obj['title_' + L]) : ''
    return v || str(obj.title) || str(obj.key)
}

// СОСТОЯНИЕ основного ответа: loading (ответа нет) | off | error | empty | ok.
// empty: отбор пуст (selection.ids + archived = 0) либо событий нет (summary.events = 0) и ответ не частичный
export function listHistory_state(p) {
    if (!isObj(p)) return 'loading'
    const s = str(p.state).trim().toLowerCase()
    if (s === 'off') return 'off'
    if (s && s !== 'ok') return 'error'
    const sel = isObj(p.selection) ? p.selection : null
    if (sel && 'ids' in sel && num(sel.ids) + num(sel.archived) <= 0) return 'empty'
    const part = p.partial === true || arr(p.partial_blocks).length > 0
    if (isObj(p.summary) && num(p.summary.events) <= 0 && !part && !listHistory_dsHasContent(p)) return 'empty'
    return 'ok'
}
// IE 2026 10 29 / ODOO-5800 (проба K6: список над DS — summary.events = 0, события в пакетах / источниках / определении; «пусто» судим по режиму)
// DS (mode 'ds'): есть содержимое, если ненулевые пакеты, загрузки / перерасчёты, события вне строк, источники или определение (summary, badges.tabs, массивы ответа)
const cnt = (v) => (Array.isArray(v) ? v.length : num(v))
export function listHistory_dsHasContent(p) {
    if (!isObj(p) || str(p.mode) !== 'ds') return false
    const S = isObj(p.summary) ? p.summary : {}
    const T = isObj(p.badges) && isObj(p.badges.tabs) ? p.badges.tabs : {}
    return [S.packets, S.loads, S.recalcs, S.unlinked_events, S.sources, S.sources_full, T.feed, T.sources, T.definition, p.packets, p.sources, p.definition].some(v => cnt(v) > 0)
}
// чтение привязки BE (_doc.list_history…) БЕЗ побочных эффектов: store.attr_get_link создаёт отсутствующий ключ (= '') — внутри computed это ломало реактивность
// (ключ list_history_detail заводился во время вычисления → watcher не срабатывал, раскрытие пакета висело в «Loading events…»); тут — только чтение по пути
export function listHistory_readBinding(record, binding) {
    let v = record
    for (const k of str(binding).split('.')) { if (!k) continue; if (v == null || typeof v !== 'object') return null; v = v[k] }
    return isObj(v) ? v : null
}
// текст ошибки: 'error: …' → '…'; иначе первая ошибка блока
export function listHistory_errorText(p) {
    if (!isObj(p)) return ''
    const m = /^\s*error\s*:?\s*(.*)$/i.exec(str(p.state))
    if (m && m[1]) return m[1]
    const e = arr(p.errors).find(x => isObj(x) && str(x.error))
    return e ? str(e.error) : (m ? str(p.state) : '')
}
const BLOCK_TITLES = { selection: 'Selection', archived: 'Archived records', journal: 'Change journal', deleted: 'Deleted records', left: 'Left the selection',
    titles: 'Titles', loads: 'Loads', definition: 'DS definition', method: 'Request', sources: 'Sources', keys: 'Row keys' }
// подпись блока через t(); неизвестный ключ — сам ключ
export function listHistory_blockTitle(block, t = (s) => s) {
    const k = str(block)
    return BLOCK_TITLES[k] ? t(BLOCK_TITLES[k]) : k
}
// ошибки блоков → [{ block, title, error }] (без пустых и дублей)
export function listHistory_blockErrors(p, t = (s) => s) {
    const out = [], seen = new Set()
    for (const e of arr(isObj(p) ? p.errors : null)) {
        if (!isObj(e) || !str(e.error)) continue
        const key = str(e.block) + '\u0001' + str(e.error)
        if (seen.has(key)) continue
        seen.add(key)
        out.push({ block: str(e.block), title: listHistory_blockTitle(e.block, t), error: str(e.error) })
    }
    return out
}

// перечни ответа (depths / kinds / who / fields / tabs) → ключи; нет перечня — запасной из кода
const keysOf = (list, fallback) => { const k = arr(list).filter(isObj).map(x => str(x.key)).filter(Boolean); return k.length ? k : fallback.slice() }
export function listHistory_isDs(p) { return isObj(p) && str(p.mode) === 'ds' }
export function listHistory_kindKeys(p) { return keysOf(isObj(p) ? p.kinds : null, listHistory_isDs(p) ? LH_KINDS_DS : LH_KINDS) }
export function listHistory_whoKeys(p) { return keysOf(isObj(p) ? p.who : null, LH_WHO) }
export function listHistory_depthKeys(p) { return keysOf(isObj(p) ? p.depths : null, LH_DEPTHS).filter(k => LH_DEPTHS.includes(k)) }
export function listHistory_fieldKeys(p) { return arr(isObj(p) ? p.fields : null).filter(f => isObj(f) && str(f.key) && f.computed !== true).map(f => str(f.key)) }

// ВЫБОР ПОЛЬЗОВАТЕЛЯ из settings_effective ответа с проверкой на перечни (мусор → умолчание):
// → { depth, slice, view, kinds: [] (все — полный список), who: [] (пусто — все), fields: [] (пусто — все), signals 0|1, all_fields 0|1, left_selection 0|1, rewrites 0|1, scope }
export function listHistory_settings(p) {
    const S = isObj(p) && isObj(p.settings_effective) ? p.settings_effective : {}
    const depths = listHistory_depthKeys(p)
    const kinds = listHistory_kindKeys(p), who = listHistory_whoKeys(p), fields = listHistory_fieldKeys(p)
    const pick = (v, list, d) => (list.includes(str(v)) ? str(v) : d)
    const sub = (v, list) => { const out = []; for (const x of arr(v)) { const k = str(x); if (list.includes(k) && !out.includes(k)) out.push(k) } return out }
    let k = sub(S.kinds, kinds)
    if (!k.length) k = kinds.slice()
    else k = kinds.filter(x => k.includes(x))   // порядок — как в перечне
    return {
        depth: pick(S.depth, depths, depths.includes('week') ? 'week' : (depths[0] || 'week')),
        slice: pick(S.slice, LH_SLICES, 'day'),
        view: pick(S.view, LH_VIEWS, 'feed'),
        kinds: k,
        who: sub(S.who, who),
        fields: sub(S.fields, fields),
        signals: flag01(S.signals),
        all_fields: flag01(S.all_fields),
        left_selection: flag01(S.left_selection),
        rewrites: flag01(S.rewrites),   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #115593: переключатель технических перезаписей): начальное состояние — из settings_effective.rewrites
        scope: str(S.scope) === 'page' ? 'page' : 'all',
    }
}

// бейдж: число → короткий текст; null у глубины (не посчитано) → «…»; нет ключа / 0 → ''
function badgeOf(p, group, key, nullDots = false) {
    const B = isObj(p) && isObj(p.badges) ? p.badges : null
    const G = B && isObj(B[group]) ? B[group] : null
    if (!G || !(key in G)) return ''
    const v = G[key]
    if (v == null) return nullDots ? '…' : ''
    return pmHistory_badgeText(v)
}
const badgeNum = (p, group, key) => { const G = isObj(p) && isObj(p.badges) && isObj(p.badges[group]) ? p.badges[group] : {}; return num(G[key]) }
const titleIn = (p, list, key, lang) => { const o = arr(isObj(p) ? p[list] : null).find(x => isObj(x) && str(x.key) === key); return o ? listHistory_title(o, lang) : key }
const SLICE_TITLES = { day: 'Day', month: 'Month' }
const DEPTH_TITLES = { week: 'Week', month: 'Month', quarter: 'Quarter', year: 'Year', all: 'All' }

// ГРУППЫ КНОПОК строки «History settings»: [{ key, label (через o.t), type: seg | multi | toggle, options: [{ key, title, badge, on }],
//   limit (multi Fields: показывать первые N), more (сколько скрыто), on / badge (toggle) }]. Мультигруппа: все выбраны = пустой выбор (не шлётся)
export function listHistory_groups(p, sel, o = {}) {
    const lang = o.lang || 'en', t = typeof o.t === 'function' ? o.t : (s) => s
    const S = isObj(sel) ? sel : listHistory_settings(p)
    const out = []
    const depths = listHistory_depthKeys(p)
    out.push({ key: 'depth', label: t('Depth'), type: 'seg',
        options: depths.map(k => ({ key: k, title: depthTitle(p, k, lang, t), tip: depthTip(k, t), badge: badgeOf(p, 'depth', k, true), on: S.depth === k })) })   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p189 єдиний вигляд полос перемикачів — заголовки, відступи, Alt-підказки пунктів): tip — Alt-подсказка пункта «что будет при выборе»
    out.push({ key: 'slice', label: t('Slice'), type: 'seg',
        options: LH_SLICES.map(k => ({ key: k, title: t(SLICE_TITLES[k]), tip: k === 'month' ? t('The feed and the calendar group events by month') : t('The feed and the calendar group events by day'), badge: badgeOf(p, 'slice', k), on: S.slice === k })) })   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p189 єдиний вигляд полос перемикачів — заголовки, відступи, Alt-підказки пунктів)
    const kinds = listHistory_kindKeys(p)
    const kSel = arr(S.kinds).length ? S.kinds : kinds
    out.push({ key: 'kinds', label: t('Kinds'), type: 'multi',
        options: kinds.map(k => { const ti = titleIn(p, 'kinds', k, lang); return { key: k, title: ti, tip: t('Show only events of the kind «{kind}»').replace('{kind}', ti), badge: badgeOf(p, 'kinds', k), on: kSel.includes(k) } }) })   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p189 єдиний вигляд полос перемикачів — заголовки, відступи, Alt-підказки пунктів)
    const who = listHistory_whoKeys(p)
    const wAll = !arr(S.who).length
    out.push({ key: 'who', label: t('Who'), type: 'multi',
        options: who.map(k => { const ti = titleIn(p, 'who', k, lang); return { key: k, title: ti, tip: t('Show only changes made by «{who}»').replace('{who}', ti), badge: badgeOf(p, 'who', k), on: wAll || S.who.includes(k) } }) })   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p189 єдиний вигляд полос перемикачів — заголовки, відступи, Alt-підказки пунктів)
    const fields = listHistory_fieldKeys(p)
    if (fields.length) {
        const fAll = !arr(S.fields).length
        const order = fields.map((k, i) => ({ k, i, n: badgeNum(p, 'fields', k) })).sort((a, b) => (b.n - a.n) || (a.i - b.i)).map(x => x.k)
        out.push({ key: 'fields', label: t('Fields'), type: 'multi', limit: LH_FIELDS_TOP, more: Math.max(0, order.length - LH_FIELDS_TOP),
            options: order.map(k => { const ti = titleIn(p, 'fields', k, lang); return { key: k, title: ti, tip: t('Show only events in which the field «{field}» changed').replace('{field}', ti), badge: badgeOf(p, 'fields', k), on: fAll || S.fields.includes(k) } }) })   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p189 єдиний вигляд полос перемикачів — заголовки, відступи, Alt-підказки пунктів)
    }
    out.push({ key: 'signals', label: t('Signals'), type: 'toggle', on: S.signals === 1, tip: t('Also show the changes of computed signal columns; the history is read again'),   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p189 єдиний вигляд полос перемикачів — заголовки, відступи, Alt-підказки пунктів)
        badge: isObj(p) && isObj(p.badges) ? pmHistory_badgeText(p.badges.signals) : '' })
    // IE 2026 10 29 / ODOO-5800 (ie-dm7 #115593: переключатель технических перезаписей): «Show technical rewrites» — рядом с Signals; виден, когда в ответе есть summary.noise (или бейдж badges.rewrites) либо уже включён; бейдж — summary.noise.rewrite_pairs
    const nz = isObj(p) && isObj(p.summary) && isObj(p.summary.noise) ? p.summary.noise : null
    const hasB = isObj(p) && isObj(p.badges) && 'rewrites' in p.badges
    if (nz || hasB || S.rewrites === 1) {
        const n = nz && ('rewrite_pairs' in nz || 'renumbered' in nz) ? num(nz.rewrite_pairs) + num(nz.renumbered) : (hasB ? num(p.badges.rewrites) : 0)   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #115849: бейдж = пары перезаписей + скрытые перенумерации summary.noise.renumbered)
        out.push({ key: 'rewrites', label: t('Show technical rewrites'), type: 'toggle', on: S.rewrites === 1, tip: t('Show the technical delete and insert events of the night rewrites as they are in the journal; the history is read again'),   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p189 єдиний вигляд полос перемикачів — заголовки, відступи, Alt-підказки пунктів)
             badge: n > 0 ? pmHistory_badgeText(n) : '' })
    }
    return out
}
// IE 2026 11 02 / ODOO-350449 (заказ Игоря: p189 єдиний вигляд полос перемикачів — заголовки, відступи, Alt-підказки пунктів): Alt-подсказка пункта глубины — что будет прочитано
function depthTip(k, t) {
    const T = { week: 'Read the history of the last week', month: 'Read the history of the last month', quarter: 'Read the history of the last three months', year: 'Read the history of the last year', all: 'Read the whole journal' }
    return T[k] ? t(T[k]) : t('Read the history of this depth')
}
function depthTitle(p, k, lang, t) {
    const o = arr(isObj(p) ? p.depths : null).find(x => isObj(x) && str(x.key) === k)
    return o ? listHistory_title(o, lang) : t(DEPTH_TITLES[k] || k)
}

// НАЖАТИЕ КНОПКИ группы → новый выбор (тот же объект не меняется). seg — значение; multi — клик = только этот (по единственному — снова все),
// additive (Shift / ⌘ / Ctrl) — добавить / снять, последний не снимается; who / fields «все» хранятся пустым списком; toggle — 0 ↔ 1
export function listHistory_pick(p, sel, group, key, additive = false) {
    const S = { ...(isObj(sel) ? sel : listHistory_settings(p)) }
    const g = str(group), k = str(key)
    if (g === 'depth') { if (listHistory_depthKeys(p).includes(k)) S.depth = k; return S }
    if (g === 'slice') { if (LH_SLICES.includes(k)) S.slice = k; return S }
    if (g === 'signals' || g === 'all_fields' || g === 'left_selection' || g === 'rewrites') { S[g] = S[g] === 1 ? 0 : 1; return S }
    const all = g === 'kinds' ? listHistory_kindKeys(p) : g === 'who' ? listHistory_whoKeys(p) : g === 'fields' ? listHistory_fieldKeys(p) : null
    if (!all || !all.includes(k)) return S
    const cur = arr(S[g]).length ? arr(S[g]).filter(x => all.includes(x)) : all.slice()
    let next
    if (additive) {
        if (cur.includes(k)) next = cur.length <= 1 ? cur : all.filter(x => x !== k && cur.includes(x))
        else next = all.filter(x => x === k || cur.includes(x))
    } else next = cur.length === 1 && cur[0] === k ? all.slice() : [k]
    const full = next.length === all.length
    S[g] = g === 'kinds' ? next : (full ? [] : next)
    return S
}
export function listHistory_additive(ev) { return !!(ev && (ev.shiftKey || ev.metaKey || ev.ctrlKey)) }

// ПОДВКЛАДКИ = вид (отдельной группы «Вид» нет, В2): tabs[] ответа с бейджами badges.tabs; нет tabs — feed / records / calendar (+ sources / definition у DS)
export function listHistory_subtabs(p, lang = 'en', t = (s) => s) {
    const FALL = { feed: 'Feed', records: 'By records', calendar: 'Calendar', sources: 'Sources', definition: 'DS definition' }
    let list = arr(isObj(p) ? p.tabs : null).filter(x => isObj(x) && LH_TABS.includes(str(x.key)))
    if (!list.length) list = (listHistory_isDs(p) ? LH_TABS : LH_VIEWS).map(k => ({ key: k }))
    const seen = new Set()
    return list.filter(x => !seen.has(str(x.key)) && seen.add(str(x.key))).map(x => {
        const k = str(x.key)
        return { key: k, title: x.title ? listHistory_title(x, lang) : t(FALL[k]), badge: badgeOf(p, 'tabs', k), view: listHistory_viewOfTab(k) }
    })
}
// вид запроса подвкладки: feed | records | calendar; sources / definition → feed (без запроса)
export function listHistory_viewOfTab(tab) { return LH_VIEWS.includes(str(tab)) ? str(tab) : 'feed' }
// нужен ли запрос при переходе на подвкладку: только feed | records | calendar с видом, отличным от текущего
export function listHistory_tabNeedsRequest(tab, sel) { return LH_VIEWS.includes(str(tab)) && str(tab) !== str(isObj(sel) ? sel.view : '') }

// вид запроса: раскрытие (packet_id / record_id / definition_audit_id) → detail, иначе main; params.history.target переопределяет
export function listHistory_kindOfHistory(h) {
    if (!isObj(h)) return 'main'
    const tg = str(h.target)
    if (tg === 'main' || tg === 'detail') return tg
    return str(h.packet_id) || str(h.record_id) || str(h.definition_audit_id) ? 'detail' : 'main'
}

// ЗАПРОС метода списка: sel — выбор пользователя, extra — патч раскрытия / дочитки / DS, o — { method, binding, seq, allKinds }.
// Не шлёт: kinds, когда выбраны все; who / fields пустые; пустые / мусорные значения extra. view — из подвкладки (sources / definition → feed).
// → { command: 'executeWidgetMethod', method, binding, params: { history }, record_sendToBackend_exclude: ['_doc'] }
export function listHistory_request(sel, extra = null, o = {}) {
    const S = isObj(sel) ? sel : {}
    const X = isObj(extra) ? extra : {}
    const h = {}
    if (LH_DEPTHS.includes(str(S.depth))) h.depth = str(S.depth)
    if (LH_SLICES.includes(str(S.slice))) h.slice = str(S.slice)
    if (S.view != null || S.tab != null) h.view = listHistory_viewOfTab(S.view != null ? S.view : S.tab)
    const allKinds = arr(o.allKinds).map(str)
    const kinds = arr(S.kinds).map(str).filter(Boolean)
    if (kinds.length && !(allKinds.length && allKinds.every(k => kinds.includes(k)))) h.kinds = kinds
    for (const k of ['who', 'fields']) { const v = arr(S[k]).map(str).filter(Boolean); if (v.length) h[k] = v }
    if (S.signals != null) h.signals = flag01(S.signals)
    if (S.all_fields != null) h.all_fields = flag01(S.all_fields)
    if (flag01(S.left_selection)) h.left_selection = 1
    if (flag01(S.rewrites)) h.rewrites = 1   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #115593: переключатель технических перезаписей): выкл → ключ не шлём
    for (const k of EXTRA_STR) if (str(X[k]).trim()) h[k] = str(X[k]).trim()
    for (const k of EXTRA_NUM) if (X[k] != null && X[k] !== '' && Number.isFinite(Number(X[k]))) h[k] = Number(X[k])
    for (const k of EXTRA_FLAG) if (X[k] != null) { if (flag01(X[k])) h[k] = 1; else if (k !== 'lite') h[k] = 0 }
    if (X.all_fields != null) h.all_fields = flag01(X.all_fields)
    if (X.signals != null) h.signals = flag01(X.signals)
    for (const k of EXTRA_LIST) if (Array.isArray(X[k]) && X[k].length) h[k] = X[k].slice()
    if (h.scope && h.scope !== 'page' && h.scope !== 'all') delete h.scope
    if (o.seq != null && o.seq !== '') h.seq = o.seq
    const kind = listHistory_kindOfHistory(h)
    return { command: 'executeWidgetMethod', method: str(o.method) || LH_METHOD,
        binding: str(kind === 'detail' ? (o.detailBinding || LH_DETAIL_BINDING) : (o.binding || LH_BINDING)),
        params: { history: h }, record_sendToBackend_exclude: ['_doc'] }
}

// СВЕРКА ОТВЕТА с отправленными запросами. track = { inflight: [{ seq, kind, gen }], gen: { main, detail }, applied: { main, detail } }
// (поколение gen растёт с каждым запросом пользователя своего вида; смена настроек поднимает оба). kind — main | detail (по binding ответа).
//   request.seq есть и найден → 'stale', если запрос старше поколения или старше уже применённого; иначе 'apply' (убираются он и более ранние того же вида);
//   request.seq есть, не найден → 'stale', если seq ≤ применённого, иначе 'foreign' (ответ на чужой запрос — ленивая загрузка вкладки) — применять;
//   request без seq (ленивая загрузка) → 'foreign'; request нет вовсе (BE v1) → по очереди: последний отправленный того же вида.
// → { verdict: 'apply' | 'stale' | 'foreign', entry, track (новый объект) }
export function listHistory_take(track, raw, kind = 'main') {
    const T = isObj(track) ? track : {}
    const list = arr(T.inflight).filter(isObj)
    const gen = { main: num(isObj(T.gen) ? T.gen.main : 0), detail: num(isObj(T.gen) ? T.gen.detail : 0) }
    const applied = { main: num(isObj(T.applied) ? T.applied.main : 0), detail: num(isObj(T.applied) ? T.applied.detail : 0) }
    const K = kind === 'detail' ? 'detail' : 'main'
    const R = isObj(raw) && isObj(raw.request) ? raw.request : null
    const seq = R ? R.seq : undefined
    const done = (verdict, entry, inflight) => {
        if (verdict !== 'stale' && entry && Number.isFinite(Number(entry.seq))) applied[K] = Math.max(applied[K], Number(entry.seq))
        else if (verdict !== 'stale' && seq != null && Number.isFinite(Number(seq))) applied[K] = Math.max(applied[K], Number(seq))
        return { verdict, entry, track: { inflight, gen, applied } }
    }
    let i = -1
    if (seq != null) {
        i = list.findIndex(x => str(x.seq) === str(seq))
        if (i < 0) return done(Number.isFinite(Number(seq)) && Number(seq) <= applied[K] ? 'stale' : 'foreign', null, list)
    } else if (R) {
        return done('foreign', null, list)
    } else {
        for (let k = list.length - 1; k >= 0; k--) if (str(list[k].kind || 'main') === K) { i = k; break }
        if (i < 0) return done('foreign', null, list)
    }
    const entry = list[i]
    const rest = list.filter((x, k) => k > i || str(x.kind || 'main') !== K)
    const old = num(entry.gen) < gen[K] || (Number.isFinite(Number(entry.seq)) && Number(entry.seq) <= applied[K])
    return done(old ? 'stale' : 'apply', entry, rest)
}

// РАСКРЫТИЕ (record._doc.list_history_detail): → { kind: packet | record | definition | '', id, found, error, events, total, offset, next, limited, partial }
export function listHistory_detailInfo(d) {
    const D = isObj(d) ? d : null
    if (!D) return { kind: '', id: '', found: false, error: '', events: [], total: 0, offset: 0, next: null, limited: false, partial: false }
    const F = isObj(D.for) ? D.for : (isObj(D.request) ? D.request : {})
    const kind = str(F.packet_id) ? 'packet' : str(F.record_id) ? 'record' : str(F.definition_audit_id) ? 'definition' : ''
    const id = kind === 'packet' ? str(F.packet_id) : kind === 'record' ? str(F.record_id) : kind === 'definition' ? str(F.definition_audit_id) : ''
    const err = listHistory_state(D) === 'error' ? listHistory_errorText(D) : ''
    const events = arr(D.events)
    return { kind, id, found: !err && D.found !== false, error: err, events,
        total: D.events_total != null ? num(D.events_total) : events.length, offset: num(D.events_offset),
        next: D.events_next_offset == null || D.events_next_offset === '' ? null : num(D.events_next_offset),
        limited: D.events_limited === true, partial: D.partial === true || arr(D.partial_blocks).length > 0 }
}
// раскрытие относится к открытому пользователем объекту (ui.packetOpen / recordOpen / definitionOpen)?
export function listHistory_detailFor(d, ui) {
    const I = listHistory_detailInfo(d), U = isObj(ui) ? ui : {}
    if (!I.kind) return false
    const want = I.kind === 'packet' ? U.packetOpen : I.kind === 'record' ? U.recordOpen : U.definitionOpen
    return !!str(want) && str(want) === I.id
}
// раскрытие не нашло объект (пакет пересобран, окно сдвинулось) → оболочка перезапрашивает основной ответ
export function listHistory_detailLost(d) { return isObj(d) && d.found === false && listHistory_state(d) !== 'error' }

// PARTIAL / «Дочитати»: → { partial, blocks (известные, без дублей), canContinue, continueFrom, done: { chunks, chunks_done } | null, badges }
export function listHistory_partial(p) {
    const P = isObj(p) ? p : {}
    const blocks = []
    for (const b of arr(P.partial_blocks)) { const k = str(b); if (k && !blocks.includes(k)) blocks.push(k) }
    const partial = P.partial === true || blocks.length > 0
    const D = isObj(P.done) ? P.done : null
    const cf = D ? str(D.continue_from) : ''
    return { partial, blocks, canContinue: partial && !!cf, continueFrom: cf,
        done: D ? { chunks: num(D.chunks), chunks_done: num(D.chunks_done) } : null, badges: P.badges_partial === true }
}

// строка сводки: «N records · M events · K packets · hidden: noise X / signals Y»
export function listHistory_summaryLine(p, t = (s) => s) {
    const S = isObj(p) && isObj(p.summary) ? p.summary : null
    if (!S) return ''
    const parts = [t('{n} records', { n: pmHistory_fmt(num(S.records)) }), t('{n} events', { n: pmHistory_fmt(num(S.events)) }), t('{n} packets', { n: pmHistory_fmt(num(S.packets)) })]
    const H = isObj(p.hidden) ? p.hidden : {}
    const noise = num(S.hidden_noise != null ? S.hidden_noise : H.noise), sig = num(S.hidden_signals != null ? S.hidden_signals : H.signals)
    if (noise || sig) parts.push(t('hidden: noise {noise} / signals {signals}', { noise: pmHistory_fmt(noise), signals: pmHistory_fmt(sig) }))
    return parts.join(' · ')
}

// дата-время ответа ('2026-10-22 11:48:00' | ISO) → «22.10 11:48»
export function listHistory_at(v) {
    const s = str(v)
    const m = /^(\d{4}-\d{2}-\d{2})[ T](\d{2}:\d{2})/.exec(s)
    return m ? pmHistory_dayLabel(m[1]) + ' ' + m[2] : pmHistory_dayLabel(s)
}

// ЗАМЕТКА ОТБОРА и ПОКРЫТИЯ журнала: → [{ key, text, warn }] (шапка вкладки)
export function listHistory_selectionNote(p, t = (s) => s) {
    if (!isObj(p)) return []
    const out = []
    const sel = isObj(p.selection) ? p.selection : null
    const W = isObj(p.window) ? p.window : null
    const win = W && (W.from || W.to) ? t('{from} — {to}', { from: listHistory_at(W.from), to: listHistory_at(W.to) }) : ''
    if (sel) {
        const mode = str(sel.mode)
        const n = pmHistory_fmt(num(sel.ids))
        if (mode === 'ids') out.push({ key: 'selection', text: t('Records under the list filter: {n}', { n }) + (win ? ' · ' + win : ''), warn: false })
        else if (mode === 'page') out.push({ key: 'selection', text: t('Records of the visible page: {n}', { n }) + (win ? ' · ' + win : ''), warn: false })
        else if (mode === 'window') out.push({ key: 'selection', text: t('All changes of the segment in the window') + (win ? ' ' + win : '') + ' · ' + t('records under the filter: {n}', { n }), warn: false })
        else if (win) out.push({ key: 'selection', text: win, warn: false })
        if (num(sel.archived)) out[out.length - 1].text += ' · ' + t('archived: {n}', { n: pmHistory_fmt(num(sel.archived)) })
        if (sel.hard_capped === true) out.push({ key: 'hard_capped', text: t('The filter is larger than the hard limit — the window is read without the id filter'), warn: true })
        else if (sel.capped === true) out.push({ key: 'capped', text: t('The filter is larger than the limit — the window is read and filtered afterwards'), warn: true })
    } else if (win) out.push({ key: 'selection', text: win, warn: false })
    const cov = str(p.coverage)
    if (cov === 'none') out.push({ key: 'coverage', text: t('No change journal for this segment — history is not available'), warn: true })
    else if (cov === 'manual_only') out.push({ key: 'coverage', text: t('Only manual edits are journaled — loads and calculations are not visible'), warn: true })
    else if (cov === 'keys') out.push({ key: 'coverage', text: t('Some sources are journaled without a link to list rows'), warn: true })
    return out
}

// снимок ответа для дочерних (markRaw ставит оболочка — только на копии, не на живых данных записи)
export function listHistory_copy(raw) {
    if (!isObj(raw)) return null
    try { return JSON.parse(JSON.stringify(raw)) } catch (e) { return null }
}
// ответ lite (первое открытие) → нужен полный запрос следом (fe.ux.listHistoryLiteFirst)
export function listHistory_needFull(p, liteFirstOn = true) { return !!liteFirstOn && isObj(p) && p.lite === true && listHistory_state(p) !== 'error' && listHistory_state(p) !== 'off' }

// IE 2026 10 29 / ODOO-5800 (заказ Игоря: история изменений списка, ie-dm7 #114916): K5 — F6 плашка partial / «Read more» и автодочитывание
const subst = (s, v) => (v ? String(s).replace(/\{(\w+)\}/g, (m, k) => (k in v ? String(v[k]) : m)) : String(s))
const trv = (t, s, v) => { const r = typeof t === 'function' ? t(s, v) : s; return subst(r, v) }
export const LH_AUTO_READ_MAX = 5   // автоповторов «Read more» подряд не больше (fe.ux.listHistoryAutoRead)
// ПЛАШКА PARTIAL: → { show, blocks: [{ key, title }], blocksText, chunksText, doneFromText, canContinue, retryOnly, patch, badges }
// canContinue — есть done.continue_from (кусками, сходится); retryOnly — частичный ответ без continue_from (DS без кусков, бюджет блоков): тот же запрос,
// из кэша бэка дочитается прочитанное, но может не дочитать (ANSWERS-BE В5). patch — патч params.history кнопки «Read more» ({ continue_from } | {}).
export function listHistory_partialView(p, t = (s) => s) {
    const P = listHistory_partial(p)
    const out = { show: false, blocks: [], blocksText: '', chunksText: '', doneFromText: '', canContinue: false, retryOnly: false, patch: null, badges: P.badges }
    if (!isObj(p) || !P.partial || listHistory_state(p) === 'error' || listHistory_state(p) === 'off') return out
    out.show = true
    out.blocks = P.blocks.filter(b => LH_PARTIAL_BLOCKS.includes(b) || BLOCK_TITLES[b]).map(b => ({ key: b, title: listHistory_blockTitle(b, t) }))
    out.blocksText = out.blocks.map(b => b.title).join(', ')
    if (P.done && P.done.chunks > 0) out.chunksText = trv(t, 'Read {done} of {chunks} parts', { done: P.done.chunks_done, chunks: P.done.chunks })
    const W = isObj(p.window) ? p.window : {}
    if (str(W.done_from)) out.doneFromText = trv(t, 'Read back to {at}', { at: listHistory_at(W.done_from) })
    out.canContinue = P.canContinue
    out.retryOnly = !P.canContinue
    out.patch = P.canContinue ? { continue_from: P.continueFrom } : {}
    return out
}
// continue_from строго старше прошлого (нет прошлого — да); даты 'YYYY-MM-DD HH:MM:SS' | ISO сравниваются как текст, иное — «не равен»
export function listHistory_cfOlder(cf, last) {
    const a = str(cf).replace('T', ' '), b = str(last).replace('T', ' ')
    if (!b) return !!a
    if (/^\d{4}-\d{2}-\d{2}/.test(a) && /^\d{4}-\d{2}-\d{2}/.test(b)) return a < b
    return a !== b
}
// АВТОДОЧИТЫВАНИЕ: auto = { n, last } (счётчик подряд и continue_from прошлого автозапроса). Повтор — только при canContinue, n < LH_AUTO_READ_MAX и СТРОГО СТАРШЕМ
// continue_from (тот же или новее — бэк не продвинулся: стоп, не зацикливать). → { go, patch, auto }
export function listHistory_autoRead(auto, p, on = true) {
    const A = isObj(auto) ? auto : { n: 0, last: '' }
    const P = listHistory_partial(p)
    // IE 2026 10 29 / ODOO-5800 (проба K6: continue_from шёл 10-19 → 10-12 → снова 10-19): повтор — только если continue_from СТРОГО старше прошлого автозапроса
    if (!on || !P.canContinue || num(A.n) >= LH_AUTO_READ_MAX || !listHistory_cfOlder(P.continueFrom, A.last)) return { go: false, patch: null, auto: A }
    return { go: true, patch: { continue_from: P.continueFrom }, auto: { n: num(A.n) + 1, last: P.continueFrom } }
}
